module.exports = __webpack_public_path__ + "static/media/instagram.0b6b3c8d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/instagram.png
// module id = 345
// module chunks = 0 1 2